var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "# icons / check 3 gradient 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ui",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-07-Inventory-ADD-7-validate-success",
    transform: "translate(-753.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "basic-info",
    transform: "translate(174.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(558.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#-icons-/-check-3-gradient-4",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "boundbox",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6568542,30.3137085 L33.0208153,18.9497475 C33.4113396,18.5592232 34.0445046,18.5592232 34.4350288,18.9497475 C34.8255531,19.3402718 34.8255531,19.9734367 34.4350288,20.363961 L23.0710678,31.7279221 L21.6568542,33.1421356 L13.7071068,25.1923882 C13.3165825,24.8018639 13.3165825,24.1686989 13.7071068,23.7781746 C14.0976311,23.3876503 14.7307961,23.3876503 15.1213203,23.7781746 L21.6568542,30.3137085 Z",
    id: "Combined-Shape",
    fill: "#6CD387",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreen);
export default __webpack_public_path__ + "static/media/checked_green.bc40b849571bf7a378bf0dbd2547b518.svg";
export { ForwardRef as ReactComponent };